import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';

// Register the Community (MIT) feature set once. No Enterprise modules.
ModuleRegistry.registerModules([AllCommunityModule]);

const FONT_FAMILY = "'Geist Variable', system-ui, -apple-system, BlinkMacSystemFont, sans-serif";
const HEADER_FONT_FAMILY = "'Geist Mono Variable', ui-monospace, monospace";

/**
 * AG Grid theme mapped to the app's design tokens via `var(--token)` so the grid
 * follows the same light/dark palette and typography as the rest of the UI.
 * Brand-blue stays reserved for the finder, so the accent is charcoal
 * `--primary`. Matches the density of the legacy table (row ~44px, header
 * ~40px, 12px horizontal padding, text-sm).
 */
export const dataGridTheme = themeQuartz.withParams({
  fontFamily: FONT_FAMILY,
  fontSize: 14,
  backgroundColor: 'var(--card)',
  foregroundColor: 'var(--foreground)',
  borderColor: 'var(--border)',
  // Tokens, never literals: this theme is shared by every grid in the app, so
  // a hard-coded colour here repaints tables that have nothing to do with
  // calls — and skips dark mode entirely, where these light values are unreadable.
  headerBackgroundColor: 'var(--muted)',
  headerTextColor: 'var(--muted-foreground)',
  headerFontFamily: HEADER_FONT_FAMILY,
  headerFontSize: 11,
  headerFontWeight: 500,
  oddRowBackgroundColor: 'transparent',
  rowHoverColor: 'color-mix(in oklab, var(--muted) 45%, transparent)',
  selectedRowBackgroundColor: 'color-mix(in oklab, var(--muted) 60%, transparent)',
  accentColor: 'var(--primary)',
  wrapperBorder: false,
  borderRadius: 0,
  wrapperBorderRadius: 0,
  rowHeight: 44,
  headerHeight: 40,
  cellHorizontalPadding: 12,
  iconSize: 14,
});
